// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
table {
  width: 100%;
  align-items: center;
  box-shadow: none;
}

footer {
  background-color: #90CAFC;
}

.header {
  background-color: #90CAFC;
  color: black;
}

.app-name {
  font-size: large;
}

.sub-header {
  background-color: #CCE2F5;
}

.page-title {
  font-size: large;
}

.searchBar {
  outline-style: none;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 12px 14px;
  width: 350px;
  font-size: 12px;
  font-weight: 500;
}

.searchBar:focus {
  border-color: #66afe9;
  outline: 0;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075), 0 0 8px rgba(102, 175, 233, 0.6);
}

.main-area {
  background-color: azure;
}

.company-name-header,
.company-name,
.created-date-header,
.created-date,
.updated-date-header,
.updated-date {
  background-color: whitesmoke;
  width: 15%;
  text-align: center;
}

.createBy-header,
.createBy,
.updateBy-header,
.updateBy {
  background-color: white;
  width: 15%;
  text-align: center;
}

.button-header {
  text-align: center;
  background-color: ghostwhite;
}

.button {
  text-align: center;
  background-color: ghostwhite;
}

.delete-button {
  background-color: lightcoral;
}

.pull-down {
  padding-top: 10px;
}

.textbox {
  padding-top: 20px;
}

.company-management-component-all {
  flex-flow: column;
  flex-wrap: wrap;
}

.company-management-component-main {
  flex: 1;
  height: 94vh;
}

.main-area {
  height: 100%;
  overflow-y: auto;
  background-color: white;
}

.no-tenant {
  color: darkorange;
}

.menu-list {
  height: 100%;
}

.footer {
  width: 100%;
  bottom: 0; /*下に固定*/
  position: fixed;
}`, "",{"version":3,"sources":["webpack://./src/app/feature/company-management/company-management.component.scss","webpack://./src/variables.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACI,WAAA;EACA,mBAAA;EACA,gBAAA;AACJ;;AAEA;EACI,yBCRa;ADSjB;;AAEA;EACI,yBCZa;EDab,YAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,yBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACI,qBAAA;EACA,UAAA;EAEA,kFAAA;AACJ;;AAEA;EACI,uBAAA;AACJ;;AAGA;;;;;;EAOA,4BAAA;EACA,UAAA;EACA,kBAAA;AADA;;AAIA;;;;EAII,uBAAA;EACA,UAAA;EACA,kBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,4BAAA;AADJ;;AAIA;EACI,kBAAA;EACA,4BAAA;AADJ;;AAIA;EACI,4BAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,iBAAA;EACA,eAAA;AADJ;;AAIA;EACI,OAAA;EACA,YAAA;AADJ;;AAIA;EACI,YAAA;EACA,gBAAA;EACA,uBAAA;AADJ;;AAIA;EACI,iBAAA;AADJ;;AAIA;EACI,YAAA;AADJ;;AAIA;EACI,WAAA;EAEA,SAAA,EAAA,OAAA;EACA,eAAA;AAFJ","sourcesContent":["@import \"variables\";\ntable{\n    width: 100%;\n    align-items: center;\n    box-shadow: none;\n}\n\nfooter{\n    background-color: $main-backgroud;\n}\n\n.header{\n    background-color: $main-backgroud;\n    color: black;\n}\n\n.app-name{\n    font-size: large;\n}\n\n.sub-header{\n    background-color: #CCE2F5;\n}\n\n.page-title{\n    font-size: large;\n}\n\n.searchBar{\n    outline-style: none ;\n    border: 1px solid #ccc;\n    border-radius: 8px;\n    padding: 12px 14px;\n    width: 350px;\n    font-size: 12px;\n    font-weight: 500;\n}\n\n.searchBar:focus{\n    border-color: #66afe9;\n    outline: 0;\n    -webkit-box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6);\n    box-shadow: inset 0 1px 1px rgba(0,0,0,.075),0 0 8px rgba(102,175,233,.6)\n}\n\n.main-area{\n    background-color:azure;\n\n}\n\n.company-name-header,\n.company-name,\n.created-date-header,\n.created-date,\n.updated-date-header,\n.updated-date\n{\nbackground-color: whitesmoke;\nwidth: 15%;\ntext-align: center;\n}\n\n.createBy-header,\n.createBy,\n.updateBy-header,\n.updateBy{\n    background-color: white;\n    width: 15%;\n    text-align: center;\n}\n\n.button-header{\n    text-align: center;\n    background-color:ghostwhite;\n}\n\n.button{\n    text-align: center;\n    background-color:ghostwhite;\n}\n\n.delete-button{\n    background-color: lightcoral;\n}\n\n.pull-down {\n    padding-top: 10px;\n}\n\n.textbox {\n    padding-top: 20px;\n}\n\n.company-management-component-all {\n    flex-flow: column;\n    flex-wrap: wrap;\n}\n\n.company-management-component-main {\n    flex: 1;\n    height: 94vh;\n}\n\n.main-area {\n    height: 100%;\n    overflow-y: auto;\n    background-color: white;\n}\n\n.no-tenant{\n    color: darkorange;\n}\n\n.menu-list{\n    height: 100%;\n}\n\n.footer {\n    width: 100%;\n    // position: absolute;/*←絶対位置*/\n    bottom: 0; /*下に固定*/\n    position: fixed;\n}","$main-backgroud: #90CAFC;\n// 本番（PRD）：背景色を薄青（#90CAFC）にする\n// STG：背景色を薄緑（#66cdaa）にする\n// DEV：背景色を黄色（#ffd700）にする\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
